import { FC } from "react";

export const CheckmarkIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.55001 17.725C9.40001 17.725 9.25835 17.7 9.12501 17.65C8.99168 17.6 8.86668 17.5167 8.75001 17.4L4.45001 13.1C4.23335 12.8833 4.12935 12.6123 4.13801 12.287C4.14601 11.9623 4.25835 11.6917 4.47501 11.475C4.69168 11.2583 4.96268 11.15 5.28801 11.15C5.61268 11.15 5.87501 11.2583 6.07501 11.475L9.55001 14.95L17.925 6.575C18.125 6.35833 18.3917 6.25 18.725 6.25C19.0583 6.25 19.3333 6.35833 19.55 6.575C19.75 6.79167 19.85 7.06233 19.85 7.387C19.85 7.71233 19.75 7.98333 19.55 8.2L10.35 17.4C10.2333 17.5167 10.1083 17.6 9.97501 17.65C9.84168 17.7 9.70001 17.725 9.55001 17.725Z"
      fill="currentColor"
    />
  </svg>
);
